import { render } from "./HistoryElementDetailsModal.vue?vue&type=template&id=0270be3a&scoped=true"
import script from "./HistoryElementDetailsModal.vue?vue&type=script&lang=js"
export * from "./HistoryElementDetailsModal.vue?vue&type=script&lang=js"

import "./HistoryElementDetailsModal.vue?vue&type=style&index=0&id=0270be3a&lang=scss"
import "./HistoryElementDetailsModal.vue?vue&type=style&index=1&id=0270be3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0270be3a"]])

export default __exports__